import localStore from 'store2';
import Snack from '@effectivastudio/snackbar';

/* c8 ignore next 11 */
if (localStore.isFake()) {
  Snack({
    pos: 'top-center',
    text: "🟡 Your device doesn't support local storage<br><br>Chat draft and unsent messages will not work after refresh!",
    customClass: 'snackbar-default',
    showAction: true,
    duration: 10000,
  });

  console.error('Your device does not support local storage');
}
